import { render, staticRenderFns } from "./PfDetails.vue?vue&type=template&id=24f2d7f0&"
import script from "./PfDetails.vue?vue&type=script&lang=js&"
export * from "./PfDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports